<template>
  <div class="service-bar">
    <div v-for="item in serviceList" :key="item.title" class="service-item">
      <div class="service-icon">
        <!-- <component :is="item.icon" /> -->
        <img :src="item.icon" class="service-icon" />
      </div>
      <div class="service-text">
        <div class="service-title">{{ item.title }}</div>
        <div class="service-desc">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps(["serviceList"]);
</script>

<style scoped lang="less">
.service-bar {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-top: 24px;
  background: #ffffff;
  box-shadow: 0px 10px 26px 0px rgba(29, 56, 97, 0.04);
  border-radius: 18px 18px 18px 18px;
  border: 1px solid #e2e9f4;
  .service-item {
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    display: flex;
    align-items: center;
    gap: 12px;
    .service-icon {
      width: 36px;
      height: 36px;
      background: #e6f0ff;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      color: #1677ff;
    }
    .service-title {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 6px;
    }
    .service-desc {
      font-size: 12px;
      color: #666;
    }
  }
}
</style>
